import { faShareNodes, faTableColumns } from '@fortawesome/pro-light-svg-icons';
import { ObjectType } from 'api-service/clients';
import { SavedEntityFormContainer } from 'areas/search/components/saved-entity-drawer/saved-entity-form-container';
import React from 'react';
import { IAction } from './interfaces';
export const actions: IAction[] = [
  {
    context: 'savedQueries',
    id: 'Sharing',
    displayName: 'Deling',
    icon: faShareNodes,
    isVisible: selctedCount => selctedCount > 0,
    action: () => <SavedEntityFormContainer objectType={ObjectType.Query} hasApplicationAreas area="arbejdslister" />,
  },
  {
    context: 'savedQueries',
    id: 'ColumnChooser',
    displayName: 'Kolonner',
    icon: faTableColumns,
    isVisible: () => true,
  },
];
